import { gsap } from 'gsap';
import { init, enter } from '../animations';

export function gameEnter(el) {
  const powerup = el.querySelector('.game-progressbar');
  const circularLife = el.querySelector('.game-score__circle');
  const textLife = el.querySelector('.game-score__text');
  const tl = gsap.timeline();

  init.get('fade')(powerup, { x: -15 });
  init.get('buttonCircular')(circularLife);
  init.get('fade')(textLife);

  tl.addLabel('start')
    .add(enter.get('fade')(powerup, 0, 0.5), 'start+=0.3')
    .add(enter.get('buttonCircular')(circularLife), 'start+=0.3')
    .add(enter.get('fade')(textLife, 0, 0.5), 'start+=0.4');

  return tl;
}

export function gameLeave(el) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, { opacity: 0, duration: 0.5, ease: 'power3.easeOut' });

  return tl;
}
